// extracted by mini-css-extract-plugin
export default {"categoriesBtn":"AdminProductsList_categoriesBtn__Wccqs","container":"AdminProductsList_container__fB5w7"};